<style></style>

<template>
    <div :class="slugToClass[size][moduleSlug]"></div>
</template>

<script>
    export default {
        components: {},
        props: {
            moduleSlug: {
                required: true,
                type: String
            },
            size: {
                default: 'lg',
                type: String
            }
        },
        data() {
            return {
                slugToClass: {
                    'lg': {
                        'child-nutrition': 'nutrition_upcoming',
                        'infant-and-child-physical-activity': 'physical_upcoming',
                        'breastfeeding-and-infant-feeding': 'infant_upcoming',
                        'outdoor-play-and-learning': 'outdoor_upcoming',
                        'farm-to-e-c-e': 'farm_upcoming',
                        'oral-health': 'oral_upcoming',
                        'screen-time': 'screen_upcoming',
                        'social-emotional': 'social_upcoming',
                    },
                    'md': {
                        'child-nutrition': 'nutrition_completed',
                        'infant-and-child-physical-activity': 'physical_completed',
                        'breastfeeding-and-infant-feeding': 'infant_completed',
                        'outdoor-play-and-learning': 'outdoor_completed',
                        'farm-to-e-c-e': 'farm_completed',
                        'oral-health': 'oral_completed',
                        'screen-time': 'screen_completed',
                        'social-emotional': 'social_completed',
                    },
                    'sm': {
                        'child-nutrition': 'nutrition_completed',
                        'infant-and-child-physical-activity': 'physical_completed',
                        'breastfeeding-and-infant-feeding': 'infant_completed',
                        'outdoor-play-and-learning': 'outdoor_completed',
                        'farm-to-e-c-e': 'farm_completed',
                        'oral-health': 'oral_completed',
                        'screen-time': 'screen_completed',
                        'social-emotional': 'social_completed',
                    }
                }
            }
        },
        methods: {}
    
}
</script>